module.exports = __webpack_public_path__ + "static/Ghazi.527d0a07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Ghazi.jpg
// module id = 1299
// module chunks = 137408898365125